/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { store as sarsaparillaStore, sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth';

import {
    searchAggregationsReducers,
    searchResultsReducers,
    searchMapSyncReducers,
} from 'ui-search';

import tripPlannerReducers from '../src/reducers/tripPlannerReducers';
import tripPlannerSearchResultsReducers from '../src/reducers/tripPlannerSearchResultsReducers';
import tripPlannerSearchSuggestionsReducers from '../src/reducers/tripPlannerSearchSuggestionsReducers';
import tripPlannerAggregations from '../src/reducers/tripPlannerAggregations';
import moduleStore from '../src/store';

const initialState = {
    ...moduleStore(),
    ...sarsaparillaStore(),
};

const rootReducer = combineReducers({
    // trip planning reducers
    tripPlanner: tripPlannerReducers,
    tripPlannerSearchSuggestions: tripPlannerSearchSuggestionsReducers,
    tripPlannerSearchResults: tripPlannerSearchResultsReducers,
    tripPlannerAggregations,

    // search module reducers
    searchResults: searchResultsReducers,
    searchAggregations: searchAggregationsReducers,
    searchMapSync: searchMapSyncReducers,

    ...sarsaparillaReducers,
    ...authReducers,
});

export function setupStore(preloadedState?: any) {
    const store = configureStore({
        preloadedState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => {
            return getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: ['launchdarkly/setClient'],
                    ignoredPaths: ['launchdarkly'],
                },
                immutableCheck: {
                    ignoredPaths: ['tripPlanner'],
                },
            });
        },
    });

    return store;
}

const store = setupStore(initialState);

export default store;
